module.exports = __webpack_public_path__ + "img/cxTrends-15.35c30693.png";